import React from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from '../../assets/loading-gif.json';

const LoadingIconClear: React.FC = () => {
  return (
    <Lottie
      loop={true}
      autoplay={true}
      animationData={loadingAnimation}
      rendererSettings={{
        preserveAspectRatio: 'xMidYMid slice'
      }}
      width={200}
    />
  );
};
export default LoadingIconClear;
